import { ServiceBase } from './ServiceBase'

export class PayScheduleType extends ServiceBase {}
